/**
 * 通用方法处理
 */
import { Message, MessageBox } from 'element-ui'
import qs from 'qs'
const CommonUtil = {
    /**
     * 提交表单
     * @param {*} form 
     * @param {*} updateMethod 
     * @param {*} addMethod 
     * @param {*} callback 
     */
    submitForm(editFlag, form, addMethod, updateMethod, callback) {
        let data = form//qs.stringify(form)
        if (editFlag) {
            updateMethod(data).then(response => {
                this.submitComplete(response, '修改成功！', callback)
            })
        } else {
            addMethod(data).then(response => {
                this.submitComplete(response, '添加成功！', callback)
            })
        }
    },

    /**
     * 提交对象完成
     * 
     */
    submitComplete(response, succMsg, callback) {
        if (response.data.status == 200) {
            Message({
                message: succMsg,
                type: 'success'
            });
            callback();
        }
    },

    //删除多条记录
    deleteMultiple(ids,deleteMultipleMethod, callback) {
        if (!ids || ids.length == 0) {
            Message({
                message: "请选择记录",
                type: 'warning'
            });
            return;
        } else {
            MessageBox.confirm('确认删除所选记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteMultipleMethod(ids).then(response => {
                    this.deleteComplete(response, callback)
                });
            });
        }
    },

    //删除单个学生
    deleteOne(params, deleteOneMethod, callback) {
        MessageBox.confirm('确认删除该记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            deleteOneMethod(params).then(response => {
                this.deleteComplete(response, callback)
            });
        });
    },

    /**
     * 删除完成
     * @param {*} response 
     * @param {*} callback 
     */
    deleteComplete(response, callback) {
        if (response.data.status == 200) {
            Message({
                message: '删除成功!',
                type: 'success'
            });
            if (callback) {
                callback()
            }

        }
    },

}

export default CommonUtil